// @core/api/endpoints/bootstrap/execute.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ExecuteBootstrapRequest,
  ExecuteBootstrapResponse,
} from '../../../types/bootstrap';

const BASE_PATH = '/bootstrap';

/**
 * Execute bootstrap
 * Starts the bootstrap execution. All wizard steps must be completed and valid. The execution pauses after vault initialization to show unseal keys — call AcknowledgeVaultKeys to continue.
 * @public This endpoint does not require authentication
 */
export async function Execute(
  data: ExecuteBootstrapRequest,
  options?: RequestOptions
): Promise<ExecuteBootstrapResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/setup/execute`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<ExecuteBootstrapResponse>(requestPath, data, requestOptions);
}
